import React from 'react';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { SvgImage, SvgImageName } from '@ardoq/icons';

const LoaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.surfaceDefault};
`;

const AnimationContainer = styled.div`
  width: 350px;
  height: 4px;
  background-color: ${colors.borderAction};
  border-radius: 10px;
  margin-top: 24px;
  position: relative;
  overflow: hidden;
`;

const MovingBar = styled.div`
  @keyframes loader-move {
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(100%);
    }
  }

  background: ${colors.surfaceBrandStrong};
  border-radius: 4px;
  height: 100%;
  width: 100%;
  animation-duration: 1.5s;
  animation-name: loader-move;
  animation-iteration-count: infinite;
`;

export const ReportBuilderLoader = () => {
  return (
    <LoaderWrapper>
      <SvgImage
        svgImageName={SvgImageName.INVERTED_ARDOQ_LOGO}
        color={colors.surfaceActionBrand}
      />
      <AnimationContainer>
        <MovingBar />
      </AnimationContainer>
    </LoaderWrapper>
  );
};
